import styled from "styled-components";
import { Typography } from "@mui/material";
import { LoyaltyPointsV2 } from "styles/general_styles";

export const Container = styled.div`
	position: absolute;
	top: 61%;
	transform: translateY(-50%);
	right: 0em;
	left: 0em;
	font-size: clamp(1px, 2.6dvw, 15px); // based on font-size: 10px;

	@media (min-width: 734px) {
		top: 67%;
		font-size: clamp(1px, 0.9dvw, 11.5px);
	}

	.bogo-button {
		font-size: 1.9em;
		margin: 0.19em auto;
		padding: 0.5em;
		z-index: 1;

		width: 91%;
		height: 2.7em;

		@media (min-width: 734px) {
			top: unset;
			width: 16em;
		}
	}
`;

export const OffersContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
	margin-bottom: 0.6em;
	height: 39em;
	&::-webkit-scrollbar {
		width: 0px;
	}

	@media (min-width: 734px) {
		flex-direction: row;
		justify-content: center;
		height: 19.5em;
	}
`;

export const OfferItem = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	//box-sizing: border-box;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.4);
	border: 0.1em solid #9aeffc;
	border-radius: 12px;
	padding: 0.8em;
	padding-bottom: 0.3em;
	height: 14em;
	z-index: 999;
	width: 86%;

	&.two-items {
		min-width: 25em;
	}

	@media (min-width: 734px) {
		width: auto;
		padding: 1.12em;
		padding-bottom: 0.3em;
		height: 16.4em;
		&.two-items {
			min-width: 36em;
			max-width: 42em;
		}
	}
`;

export const BogoItem = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;

	@media (min-width: 734px) {
		flex-direction: row;
	}
`;
export const RewardsContainer = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	padding: 0.8em 0em 0em;
	gap: 0.4em;

	@media (min-width: 734px) {
		padding: 0.8em 0em 0em;
	}
`;

export const RewardItem = styled.div<{ width: string }>`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
`;

export const RewardAmount = styled(Typography)`
	color: #fff;
	font-weight: 700;
	font-size: 1.3em;
	text-shadow: 0px 1.583px 3.959px rgba(0, 0, 0, 0.5);

	@media (min-width: 734px) {
		font-size: 1.6em;
	}
`;

export const ImageContainer = styled.div`
	position: relative;
	font-size: 0.95em;
`;

export const ItemImage = styled.img`
	width: 100%;
	height: 5.5em;
	object-fit: contain;
	justify-self: center;
	align-self: center;

	@media (min-width: 734px) {
		width: 100%;
		height: 6.5em;
	}
`;

export const Footer = styled.div`
	font-size: 0.85em;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: center;
	min-height: 5em;
	@media (min-width: 734px) {
		font-size: 1em;
	}
`;
export const CustomLoyaltyPointsV2 = styled(LoyaltyPointsV2)`
	font-size: 1.65em;
	min-height: 1.6em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: auto;
	padding: 0.2em 0.8em;
	gap: 0.1em;
`;

export const LoyaltyValue = styled.div`
	font-size: 0.95em;
	line-height: 0.95em;
`;

export const LoyaltyPoints = styled.div`
	background-color: rgba(0, 0, 0, 0.51);
	color: #fff;
	font-size: 1.44em;
	padding: 0.8em 1.28em;
	border-radius: 100px;

	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.32em;
	}
`;

interface MultiplierProps {
	image: string;
}

export const Multiplier = styled.div<MultiplierProps>`
	position: absolute;
	z-index: 1;
	font-size: 1em;
	top: 50%;
	left: 50%;
	transform: translate(10%, -95%);
	width: 3em;
	height: 3em;
	background-image: url(${(props) => props.image});
	background-size: cover;
	background-position: center;
	display: flex;
	justify-content: center;
	align-items: center;

	> div {
		color: #fff;
		font-family: Baloo;
		font-size: 1.6em;
		font-style: normal;
		font-weight: 400;
		transform: rotate(15deg);
		span {
			font-size: 0.9em;
		}
	}
	@media (min-width: 734px) {
		font-size: 1.2em;
	}
`;

export const CrossedOutValue = styled.div`
	font-size: 1.2em;
	color: #eb5757;
	line-height: 1em;
	font-weight: 700;
	text-decoration: line-through;
	text-shadow: 0px 1.583px 3.959px rgba(0, 0, 0, 0.5);
	//text-decoration-thickness: 0.1em;
	@media (min-width: 734px) {
		font-size: 1.4em;
	}
`;

export const Plus = styled.img`
	width: 4.5em;
	height: 4.5em;
	margin: 0.65em 0 0.4em;

	@media (min-width: 734px) {
		width: 5.5em;
		height: 5.5em;
		margin: 0 3em;
	}
`;

export const FreeTag = styled.img`
	position: absolute;
	top: -27%;
	width: 10.4em;
	object-fit: contain;
	right: 4%;
	@media (min-width: 734px) {
		width: 12em;
	}
`;

export const PoisBountyLabel = styled.div`
	color: #fff;

	text-align: center;
	/* Small Copy Bold */
	font-family: Inter;
	font-size: 1.4em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.4em;

	@media (min-width: 734px) {
		font-size: 1.3em;
		line-height: 1.5em;
	}
`;
